import { JsonPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, computed, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ListaTipologicheStore } from '../../../form/select-tipologica-field/select-tipologica-field.store';

@Component({
   
  imports: [MatButton, MatIcon, JsonPipe, MatProgressSpinner, MatDialogModule],
  providers: [ListaTipologicheStore],
  selector: 'siat-test-connessione-dialog',
  template: `
    <div mat-dialog-title>
      <mat-icon class="mr-2 inline-block pt-1 material-icons-outlined"
        >settings_ethernet</mat-icon
      >
      <h4 class="inline-block m-0">Test connessione</h4>
    </div>

    <div mat-dialog-content>
      @if (isLoading()) {
        <div class="flex flex-col items-center justify-center p-8 space-y-4">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="text-gray-500">Tentativo di connessione in corso...</p>
        </div>
      } @else if (error()) {
        <div
          class="bg-red-50 border border-red-200 rounded-lg p-4 flex gap-3 items-start"
        >
          <mat-icon class="text-red-600 font-bold">error_outline</mat-icon>
          <div>
            <h3 class="text-red-800 font-semibold m-0 text-sm">
              Connessione Fallita
            </h3>
            <p class="text-red-600 text-medium mt-1">
              Impossibile recuperare i dati dall'endpoint specificato.
            </p>
          </div>
        </div>
      } @else if (elements() && elements().length > 0) {
        <div
          class="flex items-center gap-2 text-green-700 mb-2 mt-4 bg-green-50 p-2 rounded border border-green-200"
        >
          <mat-icon class="text-sm h-auto w-auto">check_circle</mat-icon>
          <span class="text-medium font-semibold">Connessione riuscita</span>
        </div>

        <pre
          class="bg-gray-800 text-green-400 p-3 rounded-md overflow-auto max-h-60 text-xs"
        ><code>{{ elements() | json }}</code></pre>
      } @else {
        <div class="text-center p-6 text-gray-500">
          <mat-icon>inbox</mat-icon>
          <p>Connessione riuscita, ma nessun dato trovato.</p>
        </div>
      }
    </div>

    <div matDialogActions class="flex justify-end space-x-4">
      <button type="button" matButton (click)="close()">Chiudi</button>
    </div>
  `,
})
export class TestConnessioneDialogComponent implements OnInit {
  /**
   * The dialog ref.
   */
  public readonly dialogRef = inject(
    MatDialogRef<TestConnessioneDialogComponent>
  );

  /**
   * The endpoint.
   */
  public readonly endpoint = inject<string>(MAT_DIALOG_DATA);

  /**
   * The tipologica store.
   */
  public readonly tipologicaStore = inject(ListaTipologicheStore);

  /**
   * The loading.
   */
  isLoading = computed(() => this.tipologicaStore.isLoading() ?? false);

  /**
   * The error.
   */
  error = computed(() => this.tipologicaStore.hasError());

  /**
   * The elements.
   */
  elements = computed(() => this.tipologicaStore.pureItems());

  /**
   * The http client.
   */
  httpClient = inject(HttpClient);

  /**
   * @inheritdoc
   */
  ngOnInit(): void {
    if (this.endpoint) {
      this.tipologicaStore.fetchGetAllTipologicaItem([this.endpoint, true]);
    }
  }

  /**
   * Close dialog.
   */
  close(): void {
    const elements = this.elements();

    this.dialogRef.close(elements);
  }
}
